<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none bg-stage-background" tabindex="0">
        <form @submit.prevent="saveTicket">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h1 class="py-0.5 text-2xl font-semibold text-gray-900">Ticket umbenennen</h1>
                    </div>
                </div>
            </div>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-6 shadow sm:rounded-sm border border-bordergray-100 overflow-hidden">
                    <loading :status="loading"/>
                    <div class="bg-white md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
                        <div class="md:col-span-1">
                            <h3 class="text-lg font-medium leading-6 text-gray-900">Ticket Details</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-500">
                                Hier kann nur der Titel des Tickets geändert werden.
                            </p>
                        </div>
                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <div class="grid grid-cols-1 gap-6">
                                <div>
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="subject">Titel</label>
                                    <div class="mt-1 relative">
                                        <input
                                            id="subject"
                                            v-model="ticket.subject"
                                            class="form-input block w-full"
                                            maxlength="255"
                                            required
                                            type="text"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-100 px-4 py-3 sm:px-6 flex items-center justify-between">
                        <div class="text-xs text-gray-500">
                            Ticket ID: {{ ticket.id || '-' }}
                        </div>
                        <span class="inline-flex items-center">
                            <router-link
                                :to="ticketManagePath($route.params.id)"
                                class="btn-stage-secondary mr-4"
                            >
                                Abbrechen
                            </router-link>
                            <button class="btn-stage-primary" type="submit">
                                Ticket speichern
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </form>
    </main>
</template>

<script>
export default {
    name: "tickets-edit",
    metaInfo() {
        return {
            title: "Ticket umbenennen"
        }
    },
    data() {
        return {
            loading: true,
            ticket: {
                id: null,
                subject: '',
            },
        }
    },
    computed: {
        isCustomerTicketRoute() {
            return String(this.$route.path || '').startsWith('/tickets');
        },
    },
    mounted() {
        this.getTicket();
    },
    methods: {
        ticketListPath() {
            return this.isCustomerTicketRoute ? '/tickets/list' : '/workspace/tickets';
        },
        ticketManagePath(ticketId) {
            return this.isCustomerTicketRoute
                ? '/tickets/' + ticketId
                : '/workspace/tickets/' + ticketId + '/manage';
        },
        getTicket() {
            const self = this;
            self.loading = true;
            axios.get('api/workspace/tickets/' + self.$route.params.id).then(function (response) {
                self.ticket = {
                    id: response.data.id,
                    subject: response.data.subject || '',
                };
                self.loading = false;
            }).catch(function () {
                self.loading = false;
                self.$router.push(self.ticketListPath());
            });
        },
        saveTicket() {
            const self = this;
            self.loading = true;
            axios.put('api/workspace/tickets/' + self.$route.params.id, {
                subject: self.ticket.subject,
            }).then(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
                self.$router.push(self.ticketManagePath(self.$route.params.id));
            }).catch(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Error').toString(),
                    text: self.$i18n.t('An error occurred while saving data').toString(),
                    type: 'error'
                });
            });
        },
    }
}
</script>
